module.exports = __webpack_public_path__ + "static/media/croc-sword.dfa5ecf6.svg";